import { useState } from "react";
import { UserContextInfo } from "../../utils/types";
import { UserContext } from "./userContext";
import { helpers } from "../../utils/helpers";
import { useNavigate } from "react-router-dom";

export const UserState = (props: any) => {
    const nav = useNavigate();

    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
    const [isNewUser, setIsNewUser] = useState<boolean>(false);

    const login = () => {
        setIsLoggedIn(true);
    };

    const logout = () => {
        setIsLoggedIn(false);
        setIsNewUser(false);
    };

    const enroll = () => {
        setIsLoggedIn(true);
        setIsNewUser(true);
    };

    const navToAccount = () => {
        const randomNumber = helpers.RandomNumber(10000, 99999);
        window.localStorage.setItem("user_id", randomNumber.toString());

        nav(`/account?user_id=${randomNumber}`);
    };

    const userId: number = parseInt(window.localStorage.getItem("user_id") as string);

    const values: UserContextInfo = {
        isLoggedIn,
        isNewUser,
        userId,
        enroll,
        login,
        logout,
        navToAccount
    };

    return <UserContext.Provider value={values}>{props.children}</UserContext.Provider>;
};
